import React, { useState, useEffect } from "react";
import "./CarouselControls.css";

const CarouselControls = ({
  totalSlides,
  currentSlide,
  onNext,
  onPrev,
  onDotClick,
  variant = "dots",
  autoPlay = false,
  autoPlayInterval = 5000,
  position = "absolute"
}) => {
  const [isAutoPlaying, setIsAutoPlaying] = useState(autoPlay);

  useEffect(() => {
    if (!autoPlay || !isAutoPlaying || totalSlides <= 1) return;

    const interval = setInterval(() => {
      onNext();
    }, autoPlayInterval);

    return () => clearInterval(interval);
  }, [autoPlay, isAutoPlaying, totalSlides, autoPlayInterval, onNext]);

  const handleNext = () => {
    setIsAutoPlaying(false);
    onNext();
    setTimeout(() => setIsAutoPlaying(true), autoPlayInterval * 2);
  };

  const handlePrev = () => {
    setIsAutoPlaying(false);
    onPrev();
    setTimeout(() => setIsAutoPlaying(true), autoPlayInterval * 2);
  };

  const handleDotClick = (index) => {
    setIsAutoPlaying(false);
    onDotClick(index);
    setTimeout(() => setIsAutoPlaying(true), autoPlayInterval * 2);
  };

  return (
    <div className={`carousel-controls-container ${position}`}>
      <div className={`carousel-controls ${variant}`}>
        {/* Cambié la clase de navigation-buttons a react-navigation-buttons */}
        <div className="react-navigation-buttons">
          <button
            className="react-nav-btn"
            onClick={handlePrev}
            aria-label="Anterior"
          >
            &lt;
          </button>
          <button
            className="react-nav-btn"
            onClick={handleNext}
            aria-label="Siguiente"
          >
            &gt;
          </button>
        </div>

        {/* Indicadores dots */}
        {variant === "bar" ? (
          <div className="carousel-indicator">
            <div className="indicator-container">
              {Array.from({ length: totalSlides }).map((_, index) => (
                <div
                  key={index}
                  className={`indicator-dot ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                  aria-label={`Ir a slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="dots-indicator">
            {Array.from({ length: totalSlides }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
                aria-label={`Ir a slide ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CarouselControls;